import type { Location } from "react-router";
import { z } from "zod";

const dashboardLocationSchema = z.object({
  pathname: z.string(),
  search: z.string(),
  hash: z.string(),
});
const deviceNavigationStateSchema = z.object({
  dashboard: dashboardLocationSchema,
});

export const dashboardReturnLocation = ({
  state,
  tenantName,
}: {
  state: unknown;
  tenantName: string;
}) => {
  const fallback = {
    pathname: `/${tenantName}/admin/scrap-eye/data-dashboard`,
    search: "",
    hash: "",
  };
  const parsed = deviceNavigationStateSchema.safeParse(state);
  if (!parsed.success) return fallback;
  const { dashboard } = parsed.data;
  const suffix = dashboard.pathname.slice(fallback.pathname.length);
  return dashboard.pathname.startsWith(fallback.pathname) &&
    (suffix === "" || /^\/[^/]+$/.test(suffix)) &&
    suffix !== "/device"
    ? dashboard
    : fallback;
};

export const deviceNavigationState = ({
  location,
  tenantName,
}: {
  location: Location;
  tenantName: string;
}) => ({
  dashboard: dashboardReturnLocation({
    state: location.pathname.includes("/data-dashboard/device/")
      ? location.state
      : { dashboard: location },
    tenantName,
  }),
});
